import { IParams } from './IParams';

export function toParams(value: string): IParams {
  if (!value) return {} as IParams;
  if (value.startsWith('?')) value = value.substring(1);

  return value
    .split('&').reduce((all, p) => {

      const s = p.split('=');
      all[s[0]] = Array.isArray(all[s[0]])
        ? [...all[s[0]], s[1]]
        : [s[1]];

      return all;
    }, {} as IParams);
}
